import { GetCustomizeCar_customizeCar_prices_totalPrice } from '../../graphql/queries/__generated__/GetCustomizeCar';
import usePrice from '../../../gqlCommon/hooks/prices/usePrice';

const useTotalPrices = (totalPrice: GetCustomizeCar_customizeCar_prices_totalPrice[]) => {
  const { primaryPrice: primaryTotalPrice, secondaryPrice: secondaryTotalPrice } = usePrice(totalPrice);

  const totalPrices = [primaryTotalPrice, secondaryTotalPrice];

  return { totalPrices };
};

export default useTotalPrices;
